import AuthTopBar from "../component/AuthTopBar";
import { useNavigate } from "react-router-dom";
import GoogleSignIn from "../component/GoogleSignIn";
import AuthForm from "../component/AuthForm";
import { useState } from "react";
import { useUsersContext } from "../../../context/usersContext";
import { Toast } from "../../../components/Toast/Toast";
import { useUserInfo } from "../../../context/user";
import localforage from "localforage";
import { useSignupPlanById, useSignup } from "../../../queries/auth";

const Signup = () => {
  const params = "";
  const queryString = window.location.search;
  const planId = new URLSearchParams(queryString).get("plan");
  const type = new URLSearchParams(queryString).get("type");
  const updateUser = useUserInfo()[1];
  const logout = useUserInfo()[2];
  const [loader, setLoader] = useState(false);
  const { agency: whitelabel } = useUsersContext();
  const { data: plan } = useSignupPlanById(planId, whitelabel?._id);
  const signupMutation = useSignup();
  const navigate = useNavigate();
  const [toast, setToast] = useState({
    message: "",
    type: "error",
    isVisible: false,
    subMessage: "",
  });
  const [formInputs, setFormInputs] = useState({
    email: "",
    password: "",
    type: "email",
    userName: "",
  });

  const handleFormChange = (e) => {
    setFormInputs({ ...formInputs, [e.target.name]: e.target.value });
  };

  const handleFormSubmit = async (user) => {
    setLoader(true);
    const payload = user?.email
      ? {
        ...user,
        agency_id: whitelabel?._id,
        ...(plan && { plan_id: plan?._id }),
        ...(type ? { planType: type } : { planType: "monthly" }),
      }
      : {
        ...formInputs,
        agency_id:
          whitelabel?._id,
        ...(plan && { plan_id: plan?._id }),
        ...(type ? { planType: type } : { planType: "monthly" }),
      };
    let response, error;
    try {
      response = await signupMutation.mutateAsync(payload);
    } catch (err) {
      error = err?.response?.data;
    }
    if (response?.success) {
      setTimeout(async () => {
        if (user?.type === "google") {
          const { token, ...userData } = response.data;
          await localforage.setItem("token", token);
          updateUser(userData);
          navigate("/auth/account-setup");
        } else {
          navigate("/auth/verify-email");
        }
      }, 1000)
    } else {
      setToast({
        message: error.message,
        type: "error",
        subMessage: "Please try again",
        isVisible: true,
      });
    }
    setLoader(false);
    setTimeout(
      () =>
        setToast({
          message: "",
          type: "error",
          subMessage: "",
          isVisible: false,
        }),
      3000
    );
  };

  return (
    <div className="h-screen bg-background">
      <AuthTopBar />
      <div className="relative flex justify-center">
        <p className="text-muted-foreground absolute top-7 right-12">
          Already have an account?{" "}
          <button
            onClick={() => {
              logout();
              navigate("/auth/sign-in");
            }}
            className="text-foreground font-medium"
          >
            Sign in
          </button>
        </p>
        <div className="text-center">
          <h1 className="font-semibold text-3xl mt-[58px]">{`Create ${plan?.product_name ?? "Starter AI"
            } Account`}</h1>
          <p className="mt-3 text-center">
            Join thousands of businesses transforming with AI in minutes
          </p>
          <GoogleSignIn
            buttonText={"Sign up with Google"}
            enabled
            onSuccess={handleFormSubmit}
            onUnavailable={(message) =>
              setToast({
                message,
                type: "error",
                subMessage: "Please try again",
                isVisible: true,
              })
            }
          />
          <p className="relative border-b border-border my-6">
            <span className="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 px-4 text-muted-foreground py-2 bg-background">
              OR
            </span>
          </p>
          <p className="mb-8">Enter your email and password below to create your account</p>
          <AuthForm
            formInputs={formInputs}
            onChange={handleFormChange}
            formType="signup"
            showPasswordRequirements
            handleSubmit={handleFormSubmit}
            loader={loader}
          />
        </div>
      </div>
      <Toast
        duration={300}
        message={toast.message}
        subMessage={toast.subMessage ?? ""}
        type={toast.type}
        visible={toast.isVisible}
      />
    </div>
  );
};

export default Signup;
